module.exports = __webpack_public_path__ + "img/social-chart_ar.8288b202.svg";